import c from "../number/randomIntFromInterval.mjs";
function m(n = 1, r = 500, a = 3e3) {
  const e = [];
  for (let t = 0; t < n; t += 1) {
    const o = Math.min(a, r * 2 ** t), f = o / 2 + c(0, o / 2);
    e.push(f);
  }
  return e;
}
export {
  m as default
};
